import { ref as C, toRefs as P, watch as I, computed as D, resolveComponent as e, openBlock as a, createElementBlock as M, Fragment as N, renderSlot as v, normalizeProps as O, guardReactiveProps as G, createTextVNode as s, createBlock as f, Teleport as w, withDirectives as R, createVNode as i, vShow as V, withCtx as n, toDisplayString as T, createElementVNode as h, createCommentVNode as b } from "vue";
/* empty css                    */
import A from "./design-system.es128.js";
import E from "./design-system.es69.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
import F from "./design-system.es37.js";
import j from "./design-system.es62.js";
import q from "./design-system.es94.js";
import z from "./design-system.es106.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import { usePopper as S } from "./design-system.es119.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import H from "./design-system.es38.js";
import J from "./design-system.es59.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import K from "./design-system.es345.js";
/* empty css                    */
const L = {
  name: "DsGuideNext",
  components: {
    PulseGraphic: K,
    MenuContainer: E,
    Box: F,
    Stack: q,
    Inline: j,
    DsText: z,
    DsButton: H,
    IconButton: J
  },
  inheritAttrs: !1,
  props: {
    /**
     * Title text
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Body text
     */
    bodyText: {
      type: String,
      default: ""
    },
    /**
     * Confirmation button text
     */
    confirmText: {
      type: String,
      required: !0
    },
    /**
     * Should visually display the guide
     */
    isOpen: Boolean,
    /**
     * Position of the tooltip relative to its reference.
     */
    position: {
      type: String,
      default: "bottom",
      options: ["top", "right", "bottom", "left"]
    },
    onCancel: {
      type: Function,
      default: null
    },
    /**
     * Reference to the trigger element.  This is used for advanced cases where the trigger ref may be used for more than just the trigger.
     */
    triggerRef: {
      type: Object,
      default: null
    }
  },
  emits: [
    "confirm"
  ],
  setup(m, { emit: o }) {
    const t = C(null), r = C(null), g = C(null), { position: _, isOpen: l, triggerRef: x } = P(m);
    function p(u) {
      t.value = u;
    }
    function y(u) {
      g.value = u;
    }
    function d(u) {
      r.value = u;
    }
    function k() {
      o("confirm");
    }
    S({
      position: _,
      isOpen: l,
      trigger: t,
      menu: r
    }), S({
      position: _,
      isOpen: l,
      trigger: t,
      menu: g,
      offset: [0, 28]
    }), I(x, p, { immediate: !0 });
    const c = D(() => ({
      ref: p
    })), B = D(() => ({
      isOpen: l.value,
      attrs: c.value,
      ...c.value
    }));
    return {
      registerBeacon: d,
      registerMenu: y,
      onConfirm: k,
      triggerProps: B
    };
  }
}, Q = { class: "ds-guide-inset" };
function U(m, o, t, r, g, _) {
  const l = e("PulseGraphic"), x = e("DsText"), p = e("IconButton"), y = e("Inline"), d = e("Box"), k = e("DsButton"), c = e("Stack"), B = e("MenuContainer");
  return a(), M(N, null, [
    v(m.$slots, "default", O(G(r.triggerProps)), void 0, !0),
    o[3] || (o[3] = s()),
    (a(), f(w, { to: "body" }, [
      R(i(l, { ref: r.registerBeacon }, null, 512), [
        [V, t.isOpen]
      ]),
      o[2] || (o[2] = s()),
      i(B, {
        ref: r.registerMenu,
        "is-open": t.isOpen,
        scroll: ""
      }, {
        default: n(() => [
          i(c, null, {
            default: n(() => [
              t.bodyText ? (a(), f(d, {
                key: 0,
                padding: "spacing-200",
                "background-color": "gray-900"
              }, {
                default: n(() => [
                  i(y, { space: "spacing-200" }, {
                    default: n(() => [
                      i(x, {
                        variant: "body",
                        color: "paper",
                        as: "div",
                        style: { flex: "1" }
                      }, {
                        default: n(() => [
                          v(m.$slots, "content", {}, () => [
                            s(T(t.bodyText), 1)
                          ], !0)
                        ]),
                        _: 3
                      }),
                      o[0] || (o[0] = s()),
                      h("div", Q, [
                        t.onCancel ? (a(), f(p, {
                          key: 0,
                          name: "x",
                          class: "ds-guide-icon-button",
                          onClick: t.onCancel
                        }, null, 8, ["onClick"])) : b("", !0)
                      ])
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })) : b("", !0),
              o[1] || (o[1] = s()),
              t.confirmText ? (a(), f(d, {
                key: 1,
                "padding-x": "spacing-200",
                "padding-y": "spacing-100",
                "background-color": "ink"
              }, {
                default: n(() => [
                  i(c, { "align-x": "center" }, {
                    default: n(() => [
                      v(m.$slots, "footer", {}, () => [
                        i(k, {
                          variant: "custom",
                          dense: "",
                          class: "ds-guide-button",
                          onClick: r.onConfirm
                        }, {
                          default: n(() => [
                            s(T(t.confirmText), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], !0)
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })) : b("", !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["is-open"])
    ]))
  ], 64);
}
const Nt = /* @__PURE__ */ A(L, [["render", U], ["__scopeId", "data-v-9cc90d3a"]]);
export {
  Nt as default
};
//# sourceMappingURL=design-system.es202.js.map
